import React, { useEffect, useMemo, useRef, useState, useImperativeHandle, forwardRef, ForwardRefExoticComponent, PropsWithoutRef, RefAttributes } from 'react';
import styles from './index.module.less';
import { getSampleDraftTreeData, updateBatch, create, deleteRecord, createBatch } from './../../service';
import { postRecordList } from './../../../filterTree/service';
import { debounce } from 'lodash';
import { AssetModuleTable } from '@/asset/AssetModuleTable';
import { Api as FetchAPI } from '@cui/req';
import { PlusOutlined } from '@ant-design/icons';
import { Button, Table, Empty, Tabs, message, Input } from 'antd';

interface FeatureMaterialTableProps {
  currentSelectNode: any;
  pageType: string;
}

const FeatureMaterialTable: ForwardRefExoticComponent<PropsWithoutRef<FeatureMaterialTableProps> & RefAttributes<Record<any, any>>> = forwardRef((
  {
    currentSelectNode,
    pageType,
  },
  ref,
) => {
  const [mode, setMode] = useState<string>('view');
  const featureTableRef = useRef<any>();
  const [valueLength, setValueLength] = useState<number>(0);
  const addFeature = async () => {
    const data = {
      material_code: currentSelectNode?.id,
    };
    const res = await create({
      appId: 'master_data',
      modelId: 'md_material_feature_info',
      data,
    });
    const id = res.data.lastId;
    if (res.success && id) {
      featureTableRef.current?.addEditRecord({
        md_material_feature_info_id: id,
        ...data,
      });
    }
  };

  const deleteFeature = async (recordData: any) => {
    await onMaterialSave();
    const res = await deleteRecord({
      appId: 'master_data',
      modelId: 'md_material_feature_info',
      recordId: recordData?.md_material_feature_info_id,
    });
    if (res.success) {
      featureTableRef.current?.reload();
    }
  };

  const onMaterialSave = async () => {
    if (!currentSelectNode || mode === 'view') return;
    console.log('onMaterialSave-feature-material');
    const featureList = featureTableRef.current?.getRowsData();
    const featureMateList = featureList?.map((el: any) => {
      return {
        recordId: el.md_material_feature_info_id || '0',
        values: {
        //   feature_sn: el.feature_sn,
          feature_code: el.feature_code || null,
          feature_value_code: el.feature_value_code || null,
          feature_level_code: el.feature_level_code || null,
          md_material_feature_info_id: el.md_material_feature_info_id || null,
        },
      };
    });
    const featureUpdateList = featureMateList?.filter((el: any) => el.recordId !== '0');
    const params = {
      appId: 'master_data',
      modelId: 'md_material_feature_info',
      data: featureUpdateList?.map((el: any) => el.values) || [],
    };
    const res = await updateBatch(params);
  };

  const getDefaultData = async () => {
    const listRes = await postRecordList({
      app_id: 'base',
      model_id: 'bd_feature',
      product_type: currentSelectNode?.product_type,
    });
    const listData = listRes?.data || [];
    const featuresRes = await postRecordList({
      app_id: 'master_data',
      model_id: 'md_material_feature_info',
      material_code: currentSelectNode?.id || '',
    });
    const oldId = (featuresRes?.data || []).map((el: any) => el.md_material_feature_info_id);
    const featureList = (featuresRes?.data || []).map((el: any) => el.feature_code);
    const addData = listData.filter((el: any) => !featureList.includes(el.number));
    const addCode = addData.map((el: any) => {
      return {
        material_code: currentSelectNode?.id,
        feature_code: el.number,
      };
    });
    if (addCode.length > 0) {
      const res = await createBatch({
        appId: 'master_data',
        modelId: 'md_material_feature_info',
        data: addCode,
      });
      const ids = res?.data?.lastIdList;
      if (res.success && ids) {
        const newRes = await postRecordList({
          app_id: 'master_data',
          model_id: 'md_material_feature_info',
          material_code: currentSelectNode?.id || '',
        });
        const addNewList = (newRes?.data || []).filter((el: any) => !oldId.includes(el.md_material_feature_info_id));
        addNewList.forEach((el: any) => {
          featureTableRef.current?.addEditRecord({
            md_material_feature_info_id: el.md_material_feature_info_id,
            material_code: el.material_code,
            feature_code: el.feature_code,
          });
        });
      }
      console.log('res', res);
    }
    console.log('listData', listData, featureList, addData);
  };

  useMemo(() => {
    let newMode = 'view';
    if (pageType !== 'view') {
      newMode = 'edit';
    }
    if (!currentSelectNode?.isHighlight) {
      newMode = 'view';
    }
    setMode(newMode);
    if (newMode === 'edit') {
      getDefaultData();
    }
  }, [currentSelectNode]);

  return (
    <AssetModuleTable
      API={{ FetchAPI }}
      moduleID={'md_material_feature_info'}
      namespaceID="master_data"
      columns={[
        //   { dataIndex: 'feature_sn' },
        { dataIndex: 'feature_code' },
        { dataIndex: 'feature_value_code' },
        { dataIndex: 'feature_level_code' },
      ]}
      search={false}
      tableBaseMode={mode}
      hidePagination={pageType !== 'view' ? true : undefined}
      headerTitle={'none'}
      requestParams={{
        filter: `(material_code = '${currentSelectNode?.id}')`,
        sort: 'created_at',
        incPageNavigation: true,
        incTotal: true,
        limit: 1000,
        page: 1,
        pageCursor: '',
        version: '0',
      }}
      ref={featureTableRef}
      rowDelable={false}
      optionColumns={mode !== 'view' ? {
        title: '操作',
        valueType: 'option',
        dataIndex: 'options',
        fixed: 'right',
        width: 140,
        align: 'center',
        render: (_text: any, record: any, index: number) => (
          <span>
            <Button
              type="link"
              onClick={() => {
                deleteFeature(record);
              }}
            >
              删除
            </Button>
          </span>
        ),
      } : false}
      toolBarRender={currentSelectNode?.isHighlight && pageType !== 'view' ? [
        <>
          <Button type="primary" ghost onClick={addFeature}>
            <PlusOutlined /> 新建
          </Button>
        </>,
      ] : undefined}
      onChange={(values: any) => {
        if (values.length === 0) return;
        if (values.length !== valueLength) {
          setValueLength(values.length);
        } else {
          debounce(onMaterialSave, 1000)();
        }
      }}
    />
  );
});

export default FeatureMaterialTable;
